import { cloneDeep, defaultsDeep, find, unset } from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Store, select } from '@ngrx/store';

import { map } from 'rxjs/operators';
import { Observable, combineLatest } from 'rxjs';

import { environment } from '../../../environments/environment';
import { httpParams } from '../_utils';
import { Category } from '../../views/pages/admin/models/category.model';
import { Page } from '../../views/pages/admin/models/page.model';
import { currentUser } from '../auth';
import { AppState } from '../reducers';

const CATEGORY_API_URL = `${environment.apiPrefix}/categories`;
const PAGES_API_URL = `${environment.apiPrefix}/pages`;

export class MenuConfig {
  private defaults: any = {
    header: {
      self: {},
      items: [],
    },
    aside: {
      self: {},
      items: [
        {
          title: 'Главная',
          root: true,
          icon: 'flaticon2-architecture-and-city',
          iconType: 'simple',
          page: '/dashboard',
          translate: 'MENU.DASHBOARD',
          bullet: 'dot',
        },
      ],
    },
  };

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  public get configs$(): Observable<any> {
    return combineLatest([
      this.http.get<{ categories: Category[]; metadata: any }>(CATEGORY_API_URL, {
        params: httpParams({
          parentId: null,
          sort: 'order|asc',
        }),
      }),

      this.http.get<{ pages: Page[]; metadata: any }>(PAGES_API_URL, {
        params: httpParams({
          categoryId: null,
          sort: 'order|asc',
        }),
      }),

      this.store.pipe(select(currentUser)),
    ]).pipe(
      map(([{ categories }, { pages }, user]): any => {
        const ret = defaultsDeep({}, this.defaults);

        const addon = [];

        if (user) {
          if (find(user.roles, { name: 'admin' })) {
            addon.push({
              title: 'Настройки',
              root: true,
              // icon: '/assets/icons/settings.jpg',
              // iconType: 'jpg',
              icon: 'flaticon2-gear',
              iconType: 'simple',
              page: '/settings',
              translate: 'MENU.SETTINGS',
              bullet: 'dot',
            });
          }

          addon.push({
            title: 'Выход',
            root: true,
            icon: 'fa fa-sign-out-alt',
            iconType: 'simple',
            page: '/auth/logout',
            translate: 'MENU.LOGOUT',
            bullet: 'dot',
          });

          ret.aside.items = this.defaults.aside.items
            .concat(this.convertMenu(categories as any[]))
            .concat(this.convertMenu(pages as any[]))
            .concat(addon);
        }

        return ret;
      }),
    );
  }

  private convertMenu(menu: any[]): any[] {
    return menu.map((item: any) => this.makeItem(item));
  }

  private makeItem(item: any): any {
    const data = cloneDeep(item);

    if (!data.iconType) {
      data.iconType = 'material';
    }

    if (!data.parent && !data.slug) {
      data.root = true;
      data.toggle = 'click';
    }

    if (!data.slug) {
      data.titleRu = data[`nameRu`];
      data.titleEn = data[`nameEn`];
    } else {
      data.page = `/${data.slug}`;
    }

    if (!data.children) {
      data.children = [];
    }

    if (data.pages && data.children.concat(data.pages).length) {
      data.submenu = data.children.concat(data.pages).map((subitem: any) => this.makeItem(subitem));
    }

    unset(data, 'slug');
    unset(data, 'children');
    unset(data, 'pages');
    unset(data, 'parent');
    unset(data, 'nameEn');
    unset(data, 'nameRu');
    unset(data, 'contentEn');
    unset(data, 'contentRu');
    unset(data, 'createdAt');
    unset(data, 'updatedAt');
    unset(data, 'version');

    return data;
  }
}
